import {
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
    useStripe,
    useElements,
} from "@stripe/react-stripe-js";
import styles from "@/styles/common/Input.module.scss";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { StripeElementChangeEvent } from "@stripe/stripe-js";
import { useState } from "react";
import useOptionsStripe from "@/utils/hooks/useOptionsStripe";
import { useStore } from "@/store/index";
import { ECardElementStatus } from "@/models/user";
import Input from "../Input";
import Btn from "../Btn";

const CardFormStripe = ({
    onSuccessSaveCard,
}: {
    onSuccessSaveCard: () => void;
}) => {
    const options = useOptionsStripe();
    const stripe = useStripe();
    const elements = useElements();
    const addCreditCard = useStore(state => state.addCreditCard);
    const [cardholderName, setCardholderName] = useState("");
    const [ready, setReady] = useState(false);
    const [cardElementsStatus, setCardElementsStatus] = useState<
        Record<ECardElementStatus, boolean>
    >({
        [ECardElementStatus.CARD_NUMBER]: false,
        [ECardElementStatus.CARD_EXPIRY]: false,
        [ECardElementStatus.CARD_CVC]: false,
    });

    const cardElement = elements?.getElement(CardNumberElement);
    const isCardComplete =
        Object.values(cardElementsStatus).every(el => el) &&
        cardholderName.trim().length &&
        cardElement &&
        stripe;

    const handleCardDetailsChange = (e: StripeElementChangeEvent) => {
        if (e.elementType === ECardElementStatus.CARD_NUMBER) {
            setCardElementsStatus({
                ...cardElementsStatus,
                [ECardElementStatus.CARD_NUMBER]: e.complete,
            });
        }
        if (e.elementType === ECardElementStatus.CARD_EXPIRY) {
            setCardElementsStatus({
                ...cardElementsStatus,
                [ECardElementStatus.CARD_EXPIRY]: e.complete,
            });
        }
        if (e.elementType === ECardElementStatus.CARD_CVC) {
            setCardElementsStatus({
                ...cardElementsStatus,
                [ECardElementStatus.CARD_CVC]: e.complete,
            });
        }
    };

    const getBorderStatus = (status: boolean) =>
        status ? styles.inputSuccess : styles.inputError;

    const onClickSave = async () =>
        isCardComplete &&
        addCreditCard({
            stripe,
            cardElement,
            cardholderName,
            onSuccess: onSuccessSaveCard,
        });

    return (
        <MDBRow className={`${ready ? "" : "d-none"} my-3`}>
            <MDBCol size="12" xl="6" className={`${styles.container} mb-3`}>
                <p className="w-100">CARD NUMBER*</p>
                <div
                    className={`${styles.input} w-100 ${getBorderStatus(
                        cardElementsStatus.cardNumber
                    )}`}
                >
                    <CardNumberElement
                        options={{
                            ...options,
                            placeholder: "**** **** **** ****",
                        }}
                        onChange={handleCardDetailsChange}
                        onReady={() => setReady(true)}
                    />
                </div>
            </MDBCol>
            <MDBCol size="12" xl="6">
                <Input
                    type="text"
                    columnProps={{
                        size: 12,
                        className: "mb-xl-0 mb-3",
                    }}
                    label="CARD HOLDER"
                    required
                    name="cardholderName"
                    id="cardholderName"
                    value={cardholderName}
                    onChange={e => setCardholderName(e.target.value)}
                    diasbleStatusIcon
                />
            </MDBCol>
            <MDBCol
                size="12"
                xl="6"
                className={`${styles.container} mb-3 mb-xl-0`}
            >
                <p className="w-100">EXPIRATION DATE*</p>
                <div
                    className={`${styles.input} w-100 ${getBorderStatus(
                        cardElementsStatus.cardExpiry
                    )}`}
                >
                    <CardExpiryElement
                        options={options}
                        onChange={handleCardDetailsChange}
                    />
                </div>
            </MDBCol>
            <MDBCol
                size="12"
                xl="6"
                className={`${styles.container} mb-3 mb-xl-0`}
            >
                <p className="w-100">CVC*</p>
                <div
                    className={`${styles.input} w-100 ${getBorderStatus(
                        cardElementsStatus.cardCvc
                    )}`}
                >
                    <CardCvcElement
                        options={options}
                        onChange={handleCardDetailsChange}
                    />
                </div>
            </MDBCol>
            <MDBRow>
                <MDBCol size={12} lg={4}>
                    <Btn
                        onClick={onClickSave}
                        disabled={!isCardComplete}
                        className="my-4"
                    >
                        Save card
                    </Btn>
                </MDBCol>
            </MDBRow>
        </MDBRow>
    );
};

export default CardFormStripe;
